const internRoutes = [
    { path: '/introIntTest', name: 'Test sposobnosti', icon: 'pe-7s-hourglass' },
    { redirect: true, path: '/introIntTestOne', to: '/introIntTestOne' },
    { redirect: true, path: '/intTestOne', to: '/intTestOne' },
    { redirect: true, path: '/introIntTestTwo', to: '/introIntTestTwo' },
    { redirect: true, path: '/intTestTwo', to: '/intTestTwo' },
    { redirect: true, path: '/introIntTestThree', to: '/introIntTestThree' },
    { redirect: true, path: '/intTestThree', to: '/intTestThree' },
    { path: '/introPersonalityTest', name: 'Test ličnosti', icon: 'pe-7s-user' },
    { path: '/admissionApplication', name: 'Prijemni formular', icon: 'pe-7s-note2' },
    { redirect: true, path: '/personalityTest', to: '/personalityTest' },
    //{ path: '/introEngTest', name: 'Test engleskog', icon: 'pe-7s-users' },
    { redirect: true, path: '/engTest', to: '/engTest' },
    //{ path: '/excelTestSolutionUpload', name: 'Test excel', icon: 'pe-7s-display2' },
    { redirect: true, path: '/hamsterinoPage', to: '/hamsterinoPage' },
    { redirect: true, path: '/timeOutPage', to: '/timeOutPage' },
    { redirect: true, path: '/testEndPage', to: '/testEndPage' },
    { redirect: true, path: '/edit-profile', to: '/edit-profile' },
    { redirect: true, path: '/welcomePage', to: '/welcomePage' },
    { redirect: true, path: '/', to: '/login', name: 'Login' }
];

export default internRoutes;